import { render } from "./SelectAllDropdown.vue?vue&type=template&id=2cbfb78c"
import script from "./SelectAllDropdown.vue?vue&type=script&lang=js"
export * from "./SelectAllDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectAllDropdown.vue"]])

export default __exports__